/**
 * Plausible Analytics Event Tracking
 * 
 * Custom events for tracking key user actions.
 * Events appear in Plausible dashboard under "Goal Conversions"
 */

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string | number> }) => void;
  }
}

/**
 * Track a custom event in Plausible
 */
function trackEvent(event: string, props?: Record<string, string | number>) {
  if (typeof window !== 'undefined' && window.plausible) {
    window.plausible(event, props ? { props } : undefined);
  }
}

/**
 * User signed up (email or Google OAuth)
 */
export function trackSignup(method: 'email' | 'google' = 'email') {
  trackEvent('Signup', { method });
}

/**
 * User started a transcription job
 */
export function trackTranscriptionStarted(source: 'url' | 'upload' | 'batch' = 'url') {
  trackEvent('Transcription Started', { source });
}

/**
 * Transcription job completed successfully
 */
export function trackTranscriptionCompleted(durationMinutes?: number) {
  trackEvent('Transcription Completed', durationMinutes ? { duration_minutes: durationMinutes } : undefined);
}

/**
 * User completed a purchase/upgrade
 */
export function trackUpgrade(plan?: string) {
  trackEvent('Upgrade', plan ? { plan } : undefined);
}

/**
 * User started using chat
 */
export function trackChatStarted() {
  trackEvent('Chat Started');
}

/**
 * User enabled research mode
 */
export function trackResearchMode() {
  trackEvent('Research Mode Enabled');
}
